import { render } from "./UserNotificationIcon.vue?vue&type=template&id=2ce8e8d2"
import script from "./UserNotificationIcon.vue?vue&type=script&lang=js"
export * from "./UserNotificationIcon.vue?vue&type=script&lang=js"

import "./UserNotificationIcon.vue?vue&type=style&index=0&id=2ce8e8d2&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__